import React from 'react';
import {Row} from 'antd';
import useDataContext from '../../context/useDataContext';

const Preguntas = (props) => {

	const {
		jsonLigasConsulta
	} = useDataContext();

	return (
		<section id="Preguntas">
			{
				//<Row > gutter={[16, 16]}>
			}
			<Row>
				<div className="TituloPF">
					<p>Preguntas frecuentes</p>
				</div>
			</Row>
			<Row>
				<div className="SubtituloPF">
					<p>1. ¿Qué objetivo tiene el sistema Conóceles para la elección de integrantes del Poder Judicial de la Federación?</p>
				</div>
			</Row>
			<Row>
				<div className="TextoPF">
					<p>
					Que la ciudadanía conozca información sobre la identidad, perfil e información curricular de las personas candidatas a juzgadoras en el Proceso 
					Electoral Extraordinario y previo a la Jornada Electoral del 1 de junio de 2025, con la finalidad de que cuenten con la información 
					suficiente al momento de emitir su voto.{' '}
					</p>
				</div>
			</Row>
			<Row>
				<div className="SubtituloPF">
					<p>2. ¿Quiénes proporcionan la información del Cuestionario curricular de cada persona candidata a juzgadora? </p>
				</div>
			</Row>
			<Row>
				<div className="TextoPF">
					<p>La información es proporcionada por las personas candidatas a juzgadoras contendientes.</p>
				</div>{' '}
			</Row>
			<Row>
				<div className="SubtituloPF">
					{' '}
					<p>3. ¿Puedo compartir la información de las personas candidatas a juzgadoras en redes sociales? </p>
				</div>
			</Row>
			<Row>
				<div className="TextoPF">
					<p>
					Sí. Busca el nombre de la persona candidata a juzgadora, elige la red social que deseas usar, y comparte. 
					La información que se encuentra en el sistema es pública y puede ser compartida.
					</p>
				</div>
			</Row>
			<Row>
				<div className="SubtituloPF">
					{' '}
					<p>
					4. ¿Es una obligación de la Unidad Técnica de Transparencia y Protección de Datos 
					Personales (UTTyPDP), del INE, publicar el Cuestionario curricular de una persona candidata a juzgadora?{' '}
					</p>
				</div>
			</Row>
			<Row>
				<div className="TextoPF">
					{' '}
					<p>
					No. Esta obligación corresponde a las personas candidatas a juzgadoras y el Instituto Nacional Electoral, a 
					través de la Unidad Técnica de Transparencia y Protección de Datos Personales apoya a la difusión de la información.
					</p>
				</div>
			</Row>
			<Row>
				<div className="SubtituloPF">
					{' '}
					<p>5. ¿Cuál es el Aviso de Privacidad de la Información que proporcionan las personas candidatas a juzgadoras? </p>
				</div>
			</Row>
			<Row>
				<div className="LinksPF">
					<span style={{color: '#000'}}>Puedes consultar el </span>{' '}
					<a href={jsonLigasConsulta && jsonLigasConsulta.avisoPrivacidad} target="_blank">
						{' '}
						Aviso de Privacidad del Sistema Conóceles para la elección de integrantes del Poder Judicial de la Federación
					</a>
				</div>
			</Row>
			<Row>
				<div className="SubtituloPF">
					{' '}
					<p>6. ¿A qué cargos se están postulando las personas candidatas a juzgadoras en esta elección? </p>
				</div>
			</Row>
			<Row style={{marginTop: '-25px'}}>
				<div className="LinksPF">
					{' '}
					<span style={{color: '#000'}}>
						<br />- Ministras y Ministros de la Suprema Corte de Justicia de la Nación (SCJN).
						<br />-	Magistraturas de las Salas Superior del Tribunal Electoral del Poder Judicial de la Federación (TEPJF).
						<br />-	Magistraturas de las Salas Regionales del Tribunal Electoral del Poder Judicial de la Federación (TEPJF).
						<br />-	Personas integrantes del Tribunal de Disciplina Judicial.
						<br />-	Magistraturas de Circuito.
						<br />-	Personas Juzgadoras de Distrito.{' '}
					</span>{' '}
				</div>
			</Row>
		</section>
	);
};

export default Preguntas;
